import { render, staticRenderFns } from "./print.vue?vue&type=template&id=06960e7b&scoped=true"
import script from "./print.vue?vue&type=script&lang=js"
export * from "./print.vue?vue&type=script&lang=js"
import style0 from "./print.vue?vue&type=style&index=0&id=06960e7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06960e7b",
  null
  
)

export default component.exports